export const environment = {
  lang: {
    fr: {
      code: 'fr-FR',
      label: 'fr',
      format: {
        date: 'dd/MM/yyyy',
        time: 'hh:mm:ss',
        datetime: 'dd/MM/yyyy hh:mm:ss'
      }
    },
    en: {
      code: 'en-EN',
      label: 'fr',
      format: {
        date: 'yyyy/MM/dd',
        time: 'hh:mm:ss',
        datetime: 'yyyy/MM/dd hh:mm:ss'
      }
    },
    pt: {
      code: 'pt-PT',
      label: 'pt',
      format: {
        date: 'yyyy/MM/dd',
        time: 'hh:mm:ss',
        datetime: 'yyyy/MM/dd HH:mm'
      }
    }
  },
  name: "prod",
  tzDefault: 1,
  production: true,
  appVersion: "V2.0R002",
  enableAnalytics: true,
  versionCheckURL: 'https://myshift2.intelcia.com',
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'Accept': 'application/json',
    'Intelcia': ''
  },
  cross: {
    withCredentials: true
  },
  block: {
    SEUIL: {status: false, roles: ['ROLE_USER_MYSHIFT2_CLIENT', 'ROLE_USER_MYSHIFT2', 'ROLE_USER']}
  },
  breaks: {
    DURATION: {status: true, value: 0}
  },
  clients: ['myshift', 'myshift2', 'myshift2-client'],
  api: {
  "myshiftUrl": "https://myshift2.intelcia.com/api",
  "myformationUrl": "https://myshift2.intelcia.com/api/myshiftgateaway/myformation",
  "blocktemps": "https://myshift2.intelcia.com/api",
  "oldBlocktemps": "https://myshift2.intelcia.com/api",
  "motif": "https://myshift2.intelcia.com/api/motifs",
  "msplanning": "https://myshift2.intelcia.com/api/myshiftgateaway/msplanning",
  "mscore": "https://myshift2.intelcia.com/api/myshiftgateaway/mscore/",
  "mselastic": "https://myshift2.intelcia.com/api/myshiftgateaway/mselastic",
  "watchdog": "https://myshift2.intelcia.com/api/myshiftgateaway/watchdog",
  "bi": {
    "agent": "https://myperfs.intelcia.com/reportSPB/powerbi/Workspace/TEST_space?filter=DIM_x0020_Agent%2FMATRICULE%20eq%20%27__username__%27&rs:Command=Render&rc:Toolbar=false",
    "teams": "https://myperfs.intelcia.com/reportSPB/powerbi/Workspace/TEST_space?filter=DIM_x0020_Equipe%2FMatricule_x0020_TL%20eq%20%27__username__%27&rs:Command=Render&rc:Toolbar=false",
    "n1": "https://myperfs.intelcia.com/reportSPB/powerbi/SharedReports/Dashboard_RR_OPS?filter=DIM_x0020_Equipe%2FMatricule_x0020_OPS%20eq%20%27__username__%27&rs:Command=Render&rc:Toolbar=false"
  }
},
  oauth: {
    basic: {
      url: ['/login', '#/login'],
      roles: ['ROLE_BASIC_AUTH']
    },
    token: 'https://oauth.intelcia.com/uaa/oauth/token',
    authorize: 'https://oauth.intelcia.com/uaa/oauth/authorize',
    state: 'INTELCIA_OAUTH_SESSION_STATE',
    remoteUser: 'INTELCIA_OAUTH_REMOTE_USER',
    scope: 'openid',
    secret: 'sae1Shahph2Vae7raoy1',
    client_id: 'myshift2-client',
    response_type: 'code',
    redirectTo: 'https://myshift2.intelcia.com',
    code: 'INTELCIA_OAUTH_SESSION_CODE',
    logOut: 'https://oauth.intelcia.com/uaa/logout'
  },
  debug: {
    block: false,
    zoom: false,
    menu: false,
    calim: true
  },
  dahsborad: {
    url: 'https://dashboard.intelcia.com/'
  },
  apps: {
    mytrombino: 'https://mytrombino.intelcia.com/#/trombinoscope/profile?id='
  },
  styles: {
    reclamation: {
      mytimesheet: '220px',
      timesheet: '470px'
    }
  },
  formationRelatedRoles: [
    'ROLE_COORDI_FORMATION_MYSHIFT2', 'ROLE_FORMATEUR_MYSHIFT2'
  ],
  mauriceNewBreakApiStartDate: '2019-12-21',
  absenceTadBeginDate: '2020-04-21',
  absenceTadCode: 'ABSENCETAD',
  PrioritizedSources: {
    userNames: ["045286", "T02837"],
    countryCode: ['MU']
  },
  verroFiche: {
    joursValidationMax: 2,
    limitJours: 4,
    moreForHierarchy: 1,
    profondeurMinOPS: 0,
    profondeurMaxOPS: 1,
    profondeurMinBUM: 1,
    profondeurMaxBUM: 1,
    profondeurMinDS: 2,
    profondeurMaxDS: 30,
    permissionsUser: ['ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
    exceptionUo: {
      "agdal": "2023-02-15",
      "ma-mks-glovo meknes": "2025-06-31"
    },
    exceptionDate: '2022-09-26',
    exceptionDateOfMaurice: '2022-09-26',
    exceptionDateQMTL: '2022-09-26',
    exceptionDateFrance: '2099-03-15',
    exceptionDateColumbia: '2025-01-01',
    exceptionDateTunis: '2024-05-01',
    exceptionDatePortugal: '2099-02-15',
    exceptionDateInsourcing: '2022-12-31',
    generalExceptionDate: '2022-09-26',
    onlyOps: [
      '035922',
      'E20332',
      'E22000',
      '041187',
      'E20621'
    ],
    onlyBUMs: [
      'E20117'
    ],
    exceptionUsers: [
      '008187',
      '008292',
      '031868',
      '031897',
      '031925',
      '031993',
      '032000',
      '032010',
      '032430',
      '033545',
      '033557',
      '033904',
      '034008',
      '034018',
      '035009',
      '035119',
      '035659',
      '036162',
      '036713',
      '037615',
      '037735',
      '037800',
      '037916',
      '039736',
      '041751',
      '044868',
      '046533'
    ]
  },
  exceptionUserInjectRealise: [
    '037395', '037385', '037663', '037393', '037392', '037394', '043716', '037388', '037387', '037391', '037389', '030303', '007357', '007083', '037664', '039855', '007329', '001984', '007356', '007344', '030628', 'M00616', 'M00622', 'M01222', 'M01223', '059296', 'M01279', '031232', '042366', '034713', 'M01112', '009136', 'M01018',
    '0130004328', '0130004297', '0130004937', '0130002099', '0130004403', '0130004884', '0130004573', '0130004511', '0133000487', '0133000797', '0130004896', '0130003507',
    'E20608',
    '0130001350',
    '039854', '0690005878', '0690069079', '0690006078', '0690069100', '0690069101', '0690069071', '0690004559', '0690069156', '0690005873', '0690006142', '0690006175',
    'M00243', 'M00059', 'M00626'
  ],
  QMTLJob: ['IN12012', 'IN12013', 'IN12016'],
  featuresAccess: {
    INJECTION: ['MA','CO', 'TN', 'SN', 'CM', 'CI', 'MG', 'MU', 'FR'],
    REOPEN: ['MA', 'TN', 'SN', 'CM', 'CI', 'MG', 'MU', 'FR', 'CO'],
    UNLOCKING: ['MA', 'TN', 'SN', 'CM', 'CI', 'MG', 'MU'],
    DELEGATION: ['MA', 'TN', 'SN', 'CM', 'CI', 'MG', 'MU', 'FR', 'CO'],
    INJECTER_REALISE: ['MA','CO','TN', 'SN', 'CM', 'CI', 'MG', 'MU', 'FR'],
    TAD: ['FR', 'CO'],
    TAD_FULL_DAY: ['CO'],
    REOPEN_FICHE_PERIOD: ['MA', 'TN', 'FR', 'SN', 'CI', 'CM', 'MU', 'MG', 'CO'],
    UOS_CURRENT_USER_MERGE_PRIORITIZED_SOURCE: [
      'meknes',
      'dreux',
      'boigny'
    ],
    UOS_CURRENT_TIMESHEET_USER_MERGE_PRIORITIZED_SOURCE: [
      'ma-intownprod-daxon as',
      'ma-mo5-marjane sav',
      'ma-mo5-marjane e commerce',
      'ma-mo5-electroplanet',
      'ma-mo5-bank al yousr',
      'ma-intownprod-sc zara france'
    ],
    REPORTING: [
      'QUALITY CONTROLLER',
      'QUALITY MONITORING TEAM LEADER',
      'QUALITY MONITORING FACTORY MANAGER'
    ],
    BLACKLISTED_BREAK_MOTIFS: {
      FR: [
        "ABSENCE",
        "ABSENCECOVID",
        "APPELDEBORDE",
        "ARRIVEEANTICIPEE",
        "DECALAGE",
        "BREAKOVERRUN",
        "EARLYLEAVE",
        "WFSINDIVUALOUTAGE",
        "BREAKEXTENSION",
        "DECHARGE",
        "DEPASSEMENT",
        "DESTAFF",
        "FORMATIONINITIAL",
        "FORMATIONMUTUALISEE",
        "HEUREDEPROGRAMMEES10POURCENT",
        "HEUREDEPROGRAMMEES15POURCENT",
        "INCIDENTTAD",
        "PROBLEMEPOSITION",
        "WFHGLOUT",
        "WFHINDOUT",
        "SEUILMOINS",
        "SEUILPLUS",
        "TRAVAILNONPLANIFIE",
        "TRAVAILNONPLANIFIE10POURCENT",
        "TRAVAILNONPLANIFIE15POURCENT",
        "PROD",
        "HORSPROD",
        "ADMINISTRATIF",
        "ADMINISTRATIFMINUS",
        "FORMATIONCONTINUE",
        "CONTROLEQUALITE",
        "FORMATIONALTERNANCE",
        "PRELOGG"
      ],
      EG: [
        "ABSENCE",
        "ABSENCECOVID",
        "APPELDEBORDE",
        "ARRIVEEANTICIPEE",
        "DECALAGE",
        "BREAKOVERRUN",
        "EARLYLEAVE",
        "WFSINDIVUALOUTAGE",
        "DECHARGE",
        "DEPASSEMENT",
        "DESTAFF",
        "FORMATIONINITIAL",
        "FORMATIONMUTUALISEE",
        "HEUREDEPROGRAMMEES10POURCENT",
        "HEUREDEPROGRAMMEES15POURCENT",
        "INCIDENTTAD",
        "INCIDENTTECH",
        "OUBLIEDELOGUE",
        "PROBLEMEPOSITION",
        "WFHGLOUT",
        "WFHINDOUT",
        "SEUILMOINS",
        "SEUILPLUS",
        "TRAVAILNONLOGUE",
        "TRAVAILNONPLANIFIE",
        "TRAVAILNONPLANIFIE10POURCENT",
        "TRAVAILNONPLANIFIE15POURCENT",
        "VISITEMED",
        "PROD",
        "HORSPROD",
        "ADMINISTRATIF",
        "ADMINISTRATIFMINUS",
        "FORMATIONCONTINUE",
        "CONTROLEQUALITE",
        "FORMATIONALTERNANCE",
        "PRELOGG"
      ],
      DEFAULT:[
        "ABSENCE",
        "ABSENCECOVID",
        "APPELDEBORDE",
        "ARRIVEEANTICIPEE",
        "DECALAGE",
        "BREAKOVERRUN",
        "EARLYLEAVE",
        "WFSINDIVUALOUTAGE",
        "BREAKEXTENSION",
        "DECHARGE",
        "DEPASSEMENT",
        "DESTAFF",
        "FORMATIONINITIAL",
        "FORMATIONMUTUALISEE",
        "HEUREDEPROGRAMMEES10POURCENT",
        "HEUREDEPROGRAMMEES15POURCENT",
        "INCIDENTTAD",
        "OUBLIEDELOGUE",
        "PROBLEMEPOSITION",
        "WFHGLOUT",
        "WFHINDOUT",
        "SEUILMOINS",
        "SEUILPLUS",
        "TRAVAILNONPLANIFIE",
        "TRAVAILNONPLANIFIE10POURCENT",
        "TRAVAILNONPLANIFIE15POURCENT",
        "PROD",
        "HORSPROD",
        "ADMINISTRATIF",
        "ADMINISTRATIFMINUS",
        "FORMATIONCONTINUE",
        "CONTROLEQUALITE",
        "FORMATIONALTERNANCE",
        "PRELOGG"
      ]
    },
    BLACKLISTED_INCOHERENCE_MOTIFS: {
      EG: {
        PLUS : ['EXTENSIONPAUSE','BREAKEXTENSION'],
        MINUS : [
          'EARLYLEAVE',
          'BREAKOVERRUN',
          'INCIDENTTAD',
          'DESTAFF'
        ]
      }
    }
  }

};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts